import React from 'react';

import Home from '../templates/home';

export default () => <Home />;
